// extracted by mini-css-extract-plugin
export var acitonButtons = "_ls-0";
export var additionalIcon = "_ls-f";
export var block = "_ls-1";
export var blockContent = "_ls-7";
export var blockDescription = "_ls-8";
export var blockIcon = "_ls-9";
export var blockTitle = "_ls-6";
export var border = "_ls-a";
export var center = "_ls-l";
export var edge = "_ls-b";
export var edgeLabel = "_ls-c";
export var edgePath = "_ls-d";
export var error = "_ls-e";
export var flowchart = "_ls-g";
export var flowchartContent = "_ls-h";
export var highlighted = "_ls-3";
export var hover = "_ls-4";
export var icon = "_ls-i";
export var left = "_ls-m";
export var navButton = "_ls-j";
export var navButtons = "_ls-k";
export var right = "_ls-n";
export var selected = "_ls-2";
export var small = "_ls-5";